import { RouteDeclaration, configureStates } from "../../core/router/router-helper.provider";
import angular from "angular";

const routes: RouteDeclaration[] = [{
    state: "report.executiveReports",
    config: {
        component: "apexExecutiveReportsDashboard",
        url: "/ExecutiveReports",
        data: {
            pageHeader: "Executive Reports"
        }
    }
}];

export const ReportJobsRoutingModule = angular
    .module("apex.mainApp.reportJobs.routing", [])
    .run(configureStates(routes))
    .name;
